import clsx from "clsx";
import { useState } from "react";
import PullToRefreshContainer from "../../components/containers/pullToRefreshContainer";
import LoadingContainer from "../../components/containers/loadingContainer";
import { Route } from "../../models/routes/route";
import routesService from "../../services/routesService";
import RouteView from "./routeView";
import { ConfirmDialog } from "../../components/dialogs/confirmDialog";
import androidService from "../../services/mobile/androidService";
import { SettingsButton } from "../../components/buttons/settingsButton";

export default function RoutesPage() {
    const [groupRoutes, setGroupRoutes] = useState<Record<string, Route[]>>({});
    const [isOpenConfirmDialog, setIsOpenConfirmDialog] = useState(false);
    const [isRejectingRoute, setIsRejectingRoute] = useState(false);
    const [routeToReject, setRouteToReject] = useState<{ route: Route; index: number; date: string } | null>(null);

    const handleRouteChange = (route: Route | null, index: number, key: string) => {
        const newRoutes = { ...groupRoutes };
        route === null ? newRoutes[key].splice(index, 1) : (newRoutes[key][index] = route);
        setGroupRoutes(newRoutes);
    };

    const handleRefreshRoutes = async () => {
        const routesResponse = await routesService.get();
        setGroupRoutes(routesResponse.isOk ? routesResponse.data! : {});
        if (routesResponse.isOk) androidService.onOrdersRefreshed();
    };

    const handleOpenRejectDialog = (route: Route, index: number, date: string) => {
        setRouteToReject({ route, index, date });
        setIsOpenConfirmDialog(true);
    };

    const handleRejectRoute = async () => {
        if (!routeToReject) return;

        setIsRejectingRoute(true);
        const { isOk } = await routesService.reject(routeToReject.route.orderId);
        if (isOk) {
            handleRouteChange(null, routeToReject.index, routeToReject.date);
            androidService.stopLocationService();
        }
        setIsRejectingRoute(false);
        setIsOpenConfirmDialog(false);
        setRouteToReject(null);
    };

    const handleCloseRejectDialog = () => {
        setIsOpenConfirmDialog(false);
        setRouteToReject(null);
    };

    const noRoutesInfo =
        Object.entries(groupRoutes)?.length > 0 ? undefined : (
            <>
                <div className="text-center">
                    Активных маршрутов <span className="fw-bold">не найдено!</span>
                </div>
                <div className="text-center">Попробуйте обновить данные или свяжитесь с менеджером versta</div>
            </>
        );

    return (
        <>
            <LoadingContainer onLoading={handleRefreshRoutes} caption="Загрузка маршрутов" notFoundInfo={noRoutesInfo}>
                <PullToRefreshContainer onRefresh={handleRefreshRoutes}>
                    {Object.entries(groupRoutes).map(([date, routes], groupIndex) => (
                        <div key={groupIndex}>
                            <h6 className={clsx("text-center fw-bold", groupIndex !== 0 && "mt-4")}>{date}</h6>
                            {routes.map((route, routeIndex) => (
                                <RouteView
                                    key={routeIndex}
                                    route={route}
                                    onRouteChange={(route) => handleRouteChange(route, routeIndex, date)}
                                    onRejectRequest={() => handleOpenRejectDialog(route, routeIndex, date)}
                                />
                            ))}
                        </div>
                    ))}
                </PullToRefreshContainer>
                <ConfirmDialog
                    isOpen={isOpenConfirmDialog}
                    header={"Отказ от маршрута"}
                    confirmButtonColor={"danger"}
                    isLoading={isRejectingRoute}
                    onClose={handleCloseRejectDialog}
                    onConfirm={handleRejectRoute}
                >
                    Вы уверены, что хотите отказаться от выполнения маршрута? Отменить это действие потом будет нельзя.
                </ConfirmDialog>
            </LoadingContainer>
            <SettingsButton />
        </>
    );
}
